<template>
    <aside class="socialWrapper">
        <div class="socialShare">
            <span class="share">{{ siteContent.share }}</span>
            <a class="social facebook"
                :href="baseUrl + id"
                target="_blank">
            </a>
            <DynamicLinkModule
                class="shareOptions"
                route="post"
                alignment="left"
                :id="id"
                :title="title"
                :caption="caption"/>
        </div>
    </aside>
</template>

<script>
    import DynamicLinkModule from '@/components/templates/DynamicLinkModule'

    export default {
        name: 'SocialShare',
        components: {
            DynamicLinkModule
        },
        props: {
            id: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            },
            caption: {
                type: String,
                required: true
            }
        },
        computed: {
            baseUrl() {
                return 'https://www.facebook.com/sharer/sharer.php?u=https://creatillo.com/blog/'
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../scss/variables';

    .socialWrapper {
        margin-left: 3rem;
    }

    .facebook {
        content: var(--facebook);
    }

    .share {
        font-size: 0.65rem;
        text-align: center;
        font-weight: 700;
        color: var(--color-grey-600);
        text-transform: uppercase;
    }

    .socialShare {
        position: sticky;
        display: flex;
        flex-direction: column;
        align-items: center;
        top: 6rem;
    }

    .social {
        height: 3rem;
        width: 3rem;
        padding: 0.25rem;
        margin-right: 1.5rem;
        user-select: none;
        display: block;
        opacity: 0.7;
        transition: $transition-eio-20;

        &:hover {
            opacity: 1;
        }

        &:last-of-type {
            margin-right: 0;
        }
    }

    .shareOptions {
        margin-top: 1rem;
    }

    @media all and (max-width: 880px) {
        .socialWrapper {
            position: relative;
            z-index: 10;
            margin: 4rem auto 0 auto;
        }

        .facebook {
            margin: 0 1rem;

            &:last-of-type {
                margin-right: 1rem;
            }
        }

        .socialShare {
            flex-direction: row;
            justify-content: center;
        }

        .shareOptions {
            margin: 0;
        }
    }
</style>